import { ReactElement } from 'react';

const Tabs = ({ tabTitles, tab, setTab }) => {

  const list = () => {
    const rows: ReactElement[] = [];

    {Object.entries(tabTitles).map(([key, value]: [key: string, value: any]) => rows.push(
      <span className={`ordersTag ${key == tab ? 'activeTab' : ''}`} onClick={() => setTab(key)}>
            {value.title}
        {value.count && <span className={`numberTag ${key == tab ? 'activeTab' : ''}`}>{value.count}</span>}
          </span>)
    )}

    return rows;
  };

  return (
    <div className="dashTabs">
      {list()}
    </div>
  );
};

export default Tabs;
